// removed by extract-text-webpack-plugin
module.exports = {"orderReceipt":"_12dmY","header":"_3cU93","orderDetails":"_2pazm","invoice":"_2cYww","invoiceItem":"_2W736","total":"_2Fn5G","left":"_2sW1i","right":"_1EESC","paymentMethod":"_2NkuQ _2W736","lowerSection":"_38ELZ","label":"_1BXEV","shippingInfo":"_1L_Uq","address":"_1V2Dl","supportInfo":"_3lFzo","storeEmail":"DHjZe","storePhone":"_34_2Z","shoppingCartItem":"_2_SBh"};


//////////////////
// WEBPACK FOOTER
// ./banquet/components/OrderReceipt/index.sass
// module id = 1491
// module chunks = 1